export const getToasts = (state) => state.toasts

export default getToasts
